import script from "./StudentTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentTab.vue?vue&type=script&setup=true&lang=js"

import "./StudentTab.vue?vue&type=style&index=0&id=0b516d35&lang=scss"

const __exports__ = script;

export default __exports__